<template>
  <a href="#" class="archive-link" @click.prevent="downloadFile">
    {{ rowValue }}
  </a>
</template>

<script>
export default {
  name: "ArchiveDownloadLink",
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    rowValue: {
      type: [String, Number],
      default: ""
    }
  },
  methods: {
    downloadFile() {
      const fileUrl = this.row?.UrlArchive;
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = this.rowValue || "download";
      link.target = "_blank";
      link.click();
    }
  }
};
</script>

<style scoped>
.archive-link {
  color: #000;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;
}
</style>
